export default "__VITE_ASSET__BHdc2EZn__"